import { defaultFormImages } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import config from "config";
import apiRequest from "utils/ApiRequest/apiRequest";
import getAsyncImage from "utils/getAsyncImage";

export const getEmbedPageSettingsExternal = async ({
  userId,
  setLoading,
  setPageSettings,
}) => {
  setLoading(true);
  const parameters = {
    userId: userId,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "GetEmbedPageSettings",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      setPageSettings(response.data);
    }
    setLoading(false);
  } else {
    setLoading(false);
  }
};

export const GetEmbedDynamicPageForEdit = async ({
  setLoading,
  setFullDetailsEmbedPage,
  userName,
  setIsValidPage,
  isAnonymouse,
  demoPageId,
}) => {
  setLoading(true);
  const parameters = {
    demoPageId: demoPageId,
    isAnonymouse: isAnonymouse,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "GetEmbedDynamicPageForEdit",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      if (
        response.data.EmbedDynamicPage &&
        response.data.EmbedDynamicPage.EmbedPageUserName === userName
      ) {
        if (!response.data.EmbedDynamicPage.EmbedPageActive) {
          setIsValidPage(isAnonymouse ? true : false);
        }
        setFullDetailsEmbedPage(response.data);
      } else {
        setIsValidPage(isAnonymouse ? true : false);
        setFullDetailsEmbedPage(null);
      }
    } else {
      setIsValidPage(isAnonymouse ? true : false);
      setFullDetailsEmbedPage(null);
    }
    setLoading(false);
  } else {
    setIsValidPage(isAnonymouse ? true : false);
    setFullDetailsEmbedPage(null);
    setLoading(false);
  }
};

export const GetEmbedDynamicPageForDisplay = async ({
  setLoading,
  setFullDetailsEmbedPage,
  userName,
  setLoadImageBackground,
  setIsFormImagesLoaded,
  lang,
  setPageLanguage,
}) => {
  setLoading(true);
  const parameters = {
    userName: userName,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "GetEmbedDynamicPageForDisplay",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.EmbedDynamicPage) {
        if (response.data.EmbedDynamicPage.EmbedPageCulture) {
          setPageLanguage(response.data.EmbedDynamicPage.EmbedPageCulture);
          if (response.data.EmbedDynamicPage.EmbedPageCulture !== lang) {
            let baseUrl = config.baseurl.includes(":3000")
              ? config.baseurl.replace("https", "http")
              : config.baseurl;
            const newUrl = `${baseUrl}/${response.data.EmbedDynamicPage.EmbedPageCulture}/page/${userName}`;
            window.location.href = newUrl;
          }
        }
      }
      setFullDetailsEmbedPage(response.data);
    } else {
      setLoadImageBackground(true);
      setIsFormImagesLoaded(true);
    }
    setLoading(false);
  } else {
    setLoading(false);
  }
};

export const UpdateEmbedPageTextAndTitle = async (body) => {
  const response = await apiRequest(
    "EmbedDynamics",
    "UpdateEmbedPageTextAndTitle",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
    }
  }
};

export const updateFormTitle = async (body) => {
  const response = await apiRequest(
    "EmbedDynamics",
    "UpdateEmbedDynamicFormTitle",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
    }
  }
};

export const updateFormDescription = async (body) => {
  const response = await apiRequest(
    "EmbedDynamics",
    "UpdateEmbedDynamicFormDescription",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
    }
  }
};

export const deleteEmbedPageLogo = async ({ embedPageId, setLogoImage }) => {
  const parameters = {
    DeleteEmbedPageImagePageId: embedPageId,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "DeleteEmbedPageLogoReact",
    parameters,
    "POST"
  );
  if (response.status === "success") {
    if (response.data === 0) {
      setLogoImage("");
    } else {
    }
  }
};

export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

export const deleteEmbedFormLogo = async ({
  formId,
  formImage,
  setFormImage,
  setFullDetailsEmbedPage,
  FullDetailsEmbedPage,
}) => {
  const parameters = {
    embedDynamicId: formId,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "DeleteEmbedFormLogo",
    parameters
  );
  if (response.status === "success") {
    if (response.data === 0) {
      //get the num location of the form in the array
      const index = FullDetailsEmbedPage.EmbedDynamicForms.findIndex(
        (form) => form.Embed_Dynamic_Id === formId
      );
      getAsyncImage(`images/${defaultFormImages[index]}.webp`, setFormImage);
      const tempFullDetailsEmbedPage = FullDetailsEmbedPage;
      tempFullDetailsEmbedPage.EmbedDynamicForms.forEach((form) => {
        if (form.Embed_Dynamic_Id === formId) {
          form.Embed_Dynamic_Image_Url = formImage;
          form.Embed_Dynamic_Image = null;
        }
      });

      tempFullDetailsEmbedPage.EmbedDynamicPageFormList.forEach((form) => {
        if (form.EmbedPageFormId === formId) {
          form.EmbedPageFormImage = formImage;
        }
      });
      setFullDetailsEmbedPage(tempFullDetailsEmbedPage);
    } else {
    }
  }
};
